export default "__VITE_ASSET__BTgD0rKw__"